import type { ReactNode } from 'react'
import { PaymentMethodSelectionRadio } from './PaymentMethodSelectionRadio'

export type PaymentMethodImageSize = 'w-8 h-8' | 'w-10 h-10'

export type PaymentMethodItemProps = {
  imageSrc?: string
  imageAlt: string
  title: string
  subtitle?: ReactNode
  imageSizeClassName: PaymentMethodImageSize
  isSelected: boolean
  isDisabled?: boolean
  onSelect: () => void
}

/** Single selectable payment option row (UPI app or net-banking account). */
export function PaymentMethodItem({
  imageSrc,
  imageAlt,
  title,
  subtitle,
  imageSizeClassName,
  isSelected,
  isDisabled = false,
  onSelect,
}: PaymentMethodItemProps) {
  const showSelected = isSelected && !isDisabled

  return (
    <div
      className={`flex items-center justify-between w-full ${isDisabled ? '' : 'cursor-pointer'}`}
      onClick={isDisabled ? undefined : onSelect}
    >
      <div className='flex items-center gap-5 min-w-0 flex-1'>
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={imageAlt}
            className={`${imageSizeClassName} rounded-lg object-contain ${isDisabled ? 'opacity-40 grayscale' : ''}`}
          />
        ) : (
          <div className={`${imageSizeClassName} rounded-lg ${isDisabled ? 'opacity-40' : ''}`} />
        )}
        <div className='min-w-0'>
          <p
            className={`text-sm truncate font-medium ${isDisabled ? 'text-grey40' : 'text-grey10'}`}
          >
            {title}
          </p>
          {subtitle ? <div className='text-xs text-grey40'>{subtitle}</div> : null}
        </div>
      </div>
      <PaymentMethodSelectionRadio isSelected={showSelected} />
    </div>
  )
}
